<template>
  <t-input
    v-model="data"
    :placeholder="placeholder"
  >
    <template v-slot:suffix>
      <icon icon="search" />
    </template>
  </t-input>
</template>

<script>
import {debounce} from '@/helpers'

export default {
  props: {
    value: {
      required: false,
      type: String,
      default: null,
    },

    delay: {
      default: true,
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
  },

  data () {
    return {
      data: '',
    }
  },

  watch: {
    data () {
      return this.delay ? this.changes() : this.update()
    },
  },

  mounted () {
    this.data = this.value
  },

  methods: {
    changes: debounce(function () {
      this.update()
    }, 750),
    update () {
      this.$emit('input', this.data)
    },
  },
}
</script>

<style lang="scss" scoped>
  .el-input__suffix svg.i {
    margin-right: 4px;
  }

</style>

